function FloatingCTAIcon({ color, ...props }) {
  return (
    <svg width={32} height={32} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g
        stroke={color || "#0FB960"}
        strokeWidth={2.667}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M13.333 20L20 26.667 26.667 20" />
        <path d="M5.333 5.333h9.334A5.333 5.333 0 0120 10.667v16" />
      </g>
    </svg>
  );
}

export default FloatingCTAIcon;
